// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import BaiduMap from 'vue-baidu-map'

import htmlToPdf from '@/utils/htmlToPdf'
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToPdf)
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
import './assets/css/syhtmyi.css'
import './assets/css/base.css'
/*svg*/
import '@/assets/icons' // icon
// ElementUI.props.lockScroll.default = false;
Vue.use(ElementUI) //使用elementUI
Vue.config.productionTip = false
import axios from 'axios'
axios.defaults.baseURL = process.env.API_ROOT;//后端开发环境地址
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
/* eslint-disable no-new */

/*使用动效*/
import wow from 'wowjs'
import animated from 'wowjs/css/libs/animate.css'
//这里需要将样式用起来，

import App from './App'
import router from './router'

// 封装的全局Pagination 分页
import page from '@/components/elPage/elpage';
Vue.component('elpage',page);

Vue.use(animated)
Vue.prototype.$wow = wow;

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});

Vue.use(BaiduMap,{
  ak:"ptvs0i9Lr51L1OCNHfOfBL6yYcW0Eqci",
});
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})









// WEBPACK FOOTER //
// ./src/main.js